import React from 'react'

import './divider.scss'

const Divider = () => (
    <div id="divider" />
)

export default Divider